export default "__VITE_ASSET__DXUojQ_S__"